// ABOUTME: Filters WhatsApp application job form metadata when the feature is unavailable.
// ABOUTME: Keeps hidden wizard steps from rendering empty create and edit pages.
const removeWhatsappApplicationEntries = (items: any[] = []) =>
    items.filter(
        (item) =>
            item.id !== "whatsappApplication" &&
            item.stepId !== "whatsappApplication" &&
            item.fieldName !== "whatsappApplication" &&
            item.formGroupId !== "whatsappApplication"
    );

const removeWhatsappApplicationEntriesIfPresent = (items: any[] | undefined) =>
    Array.isArray(items) ? removeWhatsappApplicationEntries(items) : items;

export const filterWhatsappApplicationMetadata = (
    metadata: any,
    enabled: boolean
) => {
    if (enabled || !metadata?.response?.data) {
        return metadata;
    }

    return {
        ...metadata,
        response: {
            ...metadata.response,
            data: {
                ...metadata.response.data,
                MultiStepForm: removeWhatsappApplicationEntriesIfPresent(
                    metadata.response.data.MultiStepForm
                ),
                FormGroups: removeWhatsappApplicationEntriesIfPresent(
                    metadata.response.data.FormGroups
                ),
                Metadata: removeWhatsappApplicationEntriesIfPresent(
                    metadata.response.data.Metadata
                ),
                formGroups: removeWhatsappApplicationEntriesIfPresent(
                    metadata.response.data.formGroups
                ),
                metadado: removeWhatsappApplicationEntriesIfPresent(
                    metadata.response.data.metadado
                )
            }
        }
    };
};
